const MOCK_EXCHANGE_RESPONSE = {
  accessToken:
    'eyJraWQiOiJkZWZhdWx0IiwiYWxnIjoiUlMyNTYifQ.eyJpbnN0YW5jZUlkIjoiTXpnNVpITTZkV2xrUFdGc1pXdHpaWGt1YkhsellXTm9hMjkyTVVCeWEzUjJMbkoxTEc5MVBYVnpaWEp6TEc5MVBYTjFZaXhrWXoxaWJHbDBlaXhrWXoxcFpIQSIsIm5vbmNlIjoiNjM5MDU5NTkwNTYzODQyMzQ3Lk56Z3dZek0zTW1JdE5XSmtOUzAwWTJFMExUa3pNekl0WVdNeU1tVTVNV0poTldObVpUWmpZVE0yT1dFdE1USmtNeTAwTkRFMkxUazBZbU10TlRnMFlUQTBOR1V4TldJMyIsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUiLCJqdGkiOiJBY1JyQWZGZHBfZ2ZHZGN6WjdPRjN4S3I0WE1ySHY2aGlkRWtfNWJFT29FeU1XUm1OVEJoWXkwd01qSm1MVFEwTkRRdE9UazJNQzFqTlRnd05UTmtZalU1TlRZIiwiY2xpZW50X2lkIjoidmVkLXB1YmxpYyIsImV4cCI6MTc3MDM2NTg5NSwic2Vzc2lvbklkIjoiMjFkZjUwYWMtMDIyZi00NDQ0LTk5NjAtYzU4MDUzZGI1OTU2IiwidWFWZXJzaW9uIjoiMTc3MDAzMzUxMiIsImlhdCI6MTc3MDM2MjI5NSwic3ViIjoiYWxla3NleS5seXNhY2hrb3YxQHJrdHYucnUiLCJhdWQiOlsidmVkLXB1YmxpYyJdLCJ6b25lcyI6InVuaXZlcnNhbCIsImFtciI6WyJwYXNzd29yZCJdLCJ1YUlkIjoiU0hBMjU2X3ZzZE8wR2Y2OU9kOWVfMll6ZjlidDNPUzdEVEE3TEg0VUZ2YW5PU09zYk0iLCJpc3MiOiJodHRwczovL2JsaXR6LWlkcC5ya3R2LnJ1L2JsaXR6Iiwib2ZmbGluZSI6ZmFsc2V9.mock-signature',
  idToken:
    'eyJraWQiOiJkZWZhdWx0IiwiYWxnIjoiUlMyNTYifQ.eyJub25jZSI6IjYzOTA1OTU5MDU2Mzg0MjM0Ny5Oemd3WXpNM01tSXROV0prTlMwMFkyRTBMVGt6TXpJdFlXTXlNbVU1TVdKaE5XTm1aVFpqWVRNMk9XRXRNVEprTXkwME5ERTJMVGswWW1NdE5UZzBZVEEwTkdVeE5XSTMiLCJ1YV9pZCI6IlNIQTI1Nl92c2RPMEdmNjlPZDllXzJZemY5YnQzT1M3RFRBN0xINFVGdmFuT1NPc2JNIiwianRpIjoiWDh3eHFPbTNGNFRnNlR0Ulk0ODc4WUZvelI5enlFVm05cklEOUw2eWpLayIsImV4cCI6MTc3MDM3MzA5NSwidWFfdmVyIjoiMTc3MDAzMzUxMiIsImlhdCI6MTc3MDM2MjI5NSwic3ViIjoiYWxla3NleS5seXNhY2hrb3YxQHJrdHYucnUiLCJhdWQiOlsidmVkLXB1YmxpYyJdLCJhbXIiOlsicGFzc3dvcmQiXSwic2lkIjoiMjFkZjUwYWMtMDIyZi00NDQ0LTk5NjAtYzU4MDUzZGI1OTU2IiwiaXNzIjoiaHR0cHM6Ly9ibGl0ei1pZHAucmt0di5ydS9ibGl0eiJ9.mock-signature',
  expiresIn: 3600,
  tokenType: 'Bearer',
};

const MOCK_REFRESH_RESPONSE = {
  accessToken:
    'eyJraWQiOiJkZWZhdWx0IiwiYWxnIjoiUlMyNTYifQ.eyJpbnN0YW5jZUlkIjoiTXpnNVpITTZkV2xrUFdGc1pXdHpaWGt1YkhsellXTm9hMjkyTVVCeWEzUjJMbkoxTEc5MVBYVnpaWEp6TEc5MVBYTjFZaXhrWXoxaWJHbDBlaXhrWXoxcFpIQSIsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUiLCJqdGkiOiJ5RW9QS0p3YW04SENMSjNUQ3NVb1FyWjlMMi1ZOVN4LS1od1dxN2FzbDlZeU1XUm1OVEJoWXkwd01qSm1MVFEwTkRRdE9UazJNQzFqTlRnd05UTmtZalU1TlRZIiwiY2xpZW50X2lkIjoidmVkLXB1YmxpYyIsImV4cCI6MTc3MDM2NTk0NCwic2Vzc2lvbklkIjoiMjFkZjUwYWMtMDIyZi00NDQ0LTk5NjAtYzU4MDUzZGI1OTU2IiwidWFWZXJzaW9uIjoiMTc3MDAzMzUxMiIsImlhdCI6MTc3MDM2MjM0NCwic3ViIjoiYWxla3NleS5seXNhY2hrb3YxQHJrdHYucnUiLCJhdWQiOlsidmVkLXB1YmxpYyJdLCJ6b25lcyI6InVuaXZlcnNhbCIsInVhSWQiOiJTSEEyNTZfdnNkTzBHZjY5T2Q5ZV8yWXpmOWJ0M09TN0RUQTdMSDRVRnZhbk9TT3NiTSIsImlzcyI6Imh0dHBzOi8vYmxpdHotaWRwLnJrdHYucnUvYmxpdHoiLCJvZmZsaW5lIjpmYWxzZX0.mock-signature',
  idToken: null,
  expiresIn: 3600,
  tokenType: 'Bearer',
};

const MOCK_PROFILE = {
  id: 1,
  email: 'ivan.ruhkov1@rktv.ru',
  name: 'Иван',
  surname: 'Русачков',
  patronymic: 'Тутутович',
  position: 'Разработчик',
  orgName: 'РКТВ',
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const randomFail = (probability = 0.3) => {
  if (Math.random() < probability) {
    const error = new Error('Mock random error');
    error.response = { status: 500 };
    throw error;
  }
};

export default {
  async exchange() {
    await delay(300);
    return { data: { ...MOCK_EXCHANGE_RESPONSE } };
  },
  async refresh() {
    await delay(200);
    randomFail(0.5);
    return { data: { ...MOCK_REFRESH_RESPONSE } };
  },
  async getProfileData() {
    await delay(200);
    return { data: { ...MOCK_PROFILE } };
  },
};
